import request from '@/utils/http';

// 整车在途预警分页查询
export const queryByPage = (data) => {
    return request({
        url: `/api-antms/query/lsp/dispatchLcl/onwayMonitor/queryByPage`,
        method: 'post',
        data
    });
};

// 整车在途预警查询数量
export const queryCount = (data) => {
    return request({
        url: `/api-antms/query/lsp/dispatchLcl/onwayMonitor/queryCount`,
        method: 'post',
        data
    });
};
